export default __webpack_public_path__ + "static/media/art-3-main-md.9ceac95e.jpg";